<template>
    <div class="header py-1 border-b-2 border-0 border-solid">
        <div style="position: absolute">
            <p class="theme-ui-text-color theme-question-shadow font-size-18 font-bold ml-2">
                {{ currentQuizIndex + 1 }}/{{ questionCount }}
            </p>
        </div>
        <div class="text-center flex flex-row-reverse">
            <span
                class="theme-question-shadow flex-auto sm:flex-1 text-center font-size-18 font-bold mt-0 mb-0 mr-16 ml-16 md:ml-0 md:mr-0 truncate md:whitespace-normal md:overflow-auto header-quiz-title"
                >{{ title }}</span
            >
        </div>
        <div class="progress-bar" v-if="totalTime && showProgressBar"></div>
    </div>
</template>

<script>
export default {
    props: ['title', 'currentQuizIndex', 'questionCount', 'showProgressBar'],

    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('componentAlready'))
            }, 200)
        })
    },

    data() {
        return {
            totalTime: null,
            timer: null,
            pausing: false
        }
    },

    methods: {
        setTotalTime(time) {
            let count = 1000
            this.totalTime = time
            this.timer = setInterval(() => {
                if (this.pausing) {
                    return
                }

                if (!document.querySelector('.progress-bar')) {
                    count = 1000
                    return clearInterval(this.timer)
                }

                if (count <= this.totalTime) {
                    let width = (count / this.totalTime) * 100
                    document.querySelector('.progress-bar').style.width = `${width}%`
                    count += 100
                } else {
                    count = 1000
                    clearInterval(this.timer)
                }
            }, 100)
        },

        pauseProgress() {
            this.pausing = true
        },

        playProgress() {
            this.pausing = false
        },

        stopProgressBar() {
            clearInterval(this.timer)
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    border-color: var(--ui-color-alpha-50);
    position: relative;

    .header-quiz-title {
        color: var(--ui-color-alpha-70);
    }
}

.progress-bar {
    // width: 100%;
    height: 2px;
    background-color: var(--ui-color-alpha-50);
    position: absolute;
    bottom: -2px;
}
</style>
